module.exports = __webpack_public_path__ + "static/media/nuvem.882e4f17.svg";